import React from 'react'
import styles from './Loader.module.scss'

/*eslint-disable */
let animation;
/*eslint-enable */

const Loader = () => {
  return (
    <div className={styles.loaderBouncing}>

    </div>
  )
}

export default Loader
